module.exports = __webpack_public_path__ + "img/hr-red-pita-02.9b4757e5.png";